import config from "../../config";
import Request from "../Request";

export default function login(email, password, onSuccess, onFailure) {
  Request.post(`${config.legacyApiUrl}/login`, {
    user: {
      email: email,
      password: password
    }
  }, onSuccess, onFailure);
}